var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 49,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 25C27.4183 25 31 21.4183 31 17C31 12.5817 27.4183 9 23 9C18.5817 9 15 12.5817 15 17C15 21.4183 18.5817 25 23 25Z",
    stroke: "#A9ABB6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9999 27L28.6499 22.65",
    stroke: "#A9ABB6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1914 33.6758C20.1865 35.8535 18.6289 37.416 16.1289 38.1289L15.8066 37.5234C17.8818 36.9375 19.21 35.7852 19.376 34.3105H16.2559V33.6758H20.1914ZM17.2715 41.6738V38.4414H22.9062V41.6738H17.2715ZM18.0137 41.0488H22.1445V39.0566H18.0137V41.0488ZM20.2109 36V35.3555H22.1348V33.1191H22.9062V38.0703H22.1348V36H20.2109ZM26.9395 34.8086C26.9443 35.7998 27.6035 36.7959 28.7168 37.2305L28.3066 37.8262C27.4814 37.4893 26.8857 36.8496 26.5781 36.083C26.2559 36.9229 25.6309 37.665 24.7812 38.041L24.3613 37.4453C25.5039 36.9375 26.2021 35.7998 26.207 34.8086V33.6465H26.9395V34.8086ZM25.875 39.4766V38.8418H31.7246V41.791H30.9727V39.4766H25.875ZM29.1172 38.3145V33.2754H29.8398V35.3848H30.9922V33.1191H31.7246V38.3633H30.9922V36.0293H29.8398V38.3145H29.1172Z",
    fill: "#A9ABB6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.876d6caf5e6b1ac6a95ea56bf94fcb27.svg";
export { ForwardRef as ReactComponent };